export { default } from "@src/Apps/FreeTrialBiologics";
